import React from 'react'

export const lazyWithRetry = (componentImport) =>
  React.lazy(async () => {
    const pageHasAlreadyBeenRefreshed = JSON.parse(
      window.sessionStorage.getItem('page_has_been_refreshed') || 'false'
    )

    try {
      const component = await componentImport()
      // 載入成功時，重置重刷標記
      window.sessionStorage.setItem('page_has_been_refreshed', 'false')
      return component
    } catch (error) {
      if (!pageHasAlreadyBeenRefreshed) {
        // 設定已重刷標記，避免無限循環重新整理
        window.sessionStorage.setItem('page_has_been_refreshed', 'true')
        // 強制忽略快取重新整理頁面
        window.location.reload(true)
        // 回傳一個空的 component 佔位，防止 React 繼續拋出 Uncaught Error
        return { default: () => null }
      }

      // 若已經重新整理過一次卻依然失敗，才把 error 丟出
      throw error
    }
  })